module.exports = __webpack_public_path__ + "static/img/The_Story_Button.e258bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/The_Story_Button.png
// module id = 741
// module chunks = 1